import { ref } from 'vue'

// 全局响应式状态：控制校对弹窗是否自动打开
export const shouldOpenProofreadDialog = ref(false)
